import React, { FunctionComponent } from 'react';

import { BilikZoneFormUpdate } from './bilik-zone-form';
import ContentBody from 'components/content-body/content-body';
import ContentContainer from 'components/content-container/content-container';
import Content from 'components/content/content';

const BilikZoneUpdatePage: FunctionComponent = () => {
  return (
    <Content>
      <ContentBody>
        <ContentContainer>
          <BilikZoneFormUpdate />
        </ContentContainer>
      </ContentBody>
    </Content>
  );
};

export default BilikZoneUpdatePage;
